import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { AuthGuard } from 'guards/auth/auth.guard';
import { UpdateProjectComponent } from 'modules/project/update-project/update-project.component';
import { CreateProjectComponent } from 'modules/project/create-project/create-project.component';
import { AddUserToProjectComponent } from 'modules/project/add-user-to-project/add-user-to-project.component';
import { GetProjectComponent } from 'modules/project/get-project/get-project.component';
import { UserProjectPermissionComponent } from 'modules/project/user-project-permission/user-project-permission.component';
import { UserListProjectComponent } from 'modules/project/user-list-project/user-list-project.component';
import { ProjectUserPermissionsComponent } from 'modules/project/project-user-permissions/project-user-permissions.component';
import { SharedModule } from 'modules/shared/shared.module';
import { TicketModule } from 'modules/ticket/ticket.module';
import { TicketAttributeModule } from 'modules/ticket-attribute/ticket-attribute.module';
import { EditProjectComponent } from 'modules/project/edit-project/edit-project.component';
import { ArcgisModule } from 'modules/arcgis/arcgis.module';
import { TicketCategoryModule } from 'modules/ticket-category/ticket-category.module';

@NgModule({
  declarations: [
    CreateProjectComponent,
    UpdateProjectComponent,
    AddUserToProjectComponent,
    GetProjectComponent,
    UserProjectPermissionComponent,
    UserListProjectComponent,
    ProjectUserPermissionsComponent,
    EditProjectComponent,
  ],
  exports: [
    CreateProjectComponent,
  ],
  imports: [
    ArcgisModule,
    CommonModule,
    FormsModule,
    SharedModule,
    TicketAttributeModule,
    TicketCategoryModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatRippleModule,
    MatDialogModule,
    MatSnackBarModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatAutocompleteModule,
    MatMenuModule,
    TicketModule,
    MatIconModule,
    MatExpansionModule,
    RouterModule.forChild([
      {
        path: 'create',
        component: CreateProjectComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'get',
        component: GetProjectComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'edit',
        component: EditProjectComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'adduser',
        component: AddUserToProjectComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'permissions',
        component: ProjectUserPermissionsComponent,
        canActivate: [AuthGuard],
      },
    ]),
  ],
  entryComponents: [
    CreateProjectComponent,
  ],
})
export class ProjectModule { }
